module.exports = __webpack_public_path__ + "static/img/组 2849.6f2fded.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2849.png
// module id = FF4o
// module chunks = 0